<script lang="ts" setup>
import { NuxtLinkLocale } from "#components";

const emit = defineEmits(["continue"]);
const { getPrivateKey } = useWeb3();

const isPKexists = ref(false);

onMounted(async () => {
  const pk = await getPrivateKey().catch(() => null);
  isPKexists.value = !!pk;
});
</script>

<template>
  <div class="flex flex-col items-center gap-4 max-w-md mx-auto my-4">
    <BaseIcon name="GFAL_warning" class="w-20 h-20 my-4" />
    <h3 class="text-neutral-200 text-2xl font-bold">
      {{ $t("main.modalUserWalletCreate.walletSecurityUpdate") }}
    </h3>
    <p class="text-neutral-300 max-w-sm text-center">
      {{ $t("main.modalUserWalletCreate.walletSecurityUpdateInfo") }}
    </p>
    <component :is="isPKexists ? 'button' : NuxtLinkLocale" to="/rescue">
      <BaseButtonSubmit
        :text="$t('main.modalUserWalletCreate.continue')"
        class="w-64"
        @click="isPKexists ? emit('continue') : null" />
    </component>
  </div>
</template>
